import { labelConfig } from "../constants/labelConfig";

export function getLabel(key, context) {
    const config = labelConfig[key];
    if (!config) return key;

    const match = config.overrides.find(override =>
        Object.entries(override)
            .filter(([field]) => field !== "label")
            .every(([field, value]) => context[field] === value)
    );

    return match?.label ?? config.default;
}
